import { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import { SFPalette } from '@/lib/color';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';


const MaskBox = styled(Box)({
  borderRadius: '20px',
  position: 'relative',
  background: '#F5F5F5',
  display: 'flex',
  width: '100%',
});

const Mask = styled(Box)(({ theme }) => ({
  width: '50%',
  height: '48px',
  borderRadius: '20px',
  background: 'white',
  position: 'absolute',
  border: '2px solid #F5F5F5',
  transition: 'all 0.2s ease',
}));

const CustomButton = styled(Button)({
  borderRadius: '20px',
  width: '50%',
  height: '48px',
  fontWeight: 'bold',
  transition: 'all 0.2s 0.1s ease',
  '&:hover': {
    opacity: 0.8,
  },
});

export default function SwitchWithText({
  firstText,
  secondText,
  setTypes,
  onSelectFirst,
  onSelectSecond,
}: {
  firstText: string;
  secondText: string;
  setTypes?: (value: string) => void;
  onSelectFirst?: () => void;
  onSelectSecond?: () => void;
}) {
  const [subType, setSubType] = useState('first');
  const theme = useTheme();

  return (
    <>
      <Box mb={3}>
        <MaskBox>
          <Mask
            sx={{
              transform: `translateX(${subType === 'first' ? 0 : '100%'})`,
            }}
          />
          <CustomButton
            disableRipple
            variant="text"
            sx={{
              color: subType === 'first' ? theme.palette.primary.main : SFPalette.grey2,
            }}
            onClick={() => {
              setSubType('first');
              setTypes && setTypes('first')
              onSelectFirst && onSelectFirst();
            }}
          >
            <Typography variant="h6" fontWeight={700}>
              {firstText}
            </Typography>
          </CustomButton>
          <CustomButton
            disableRipple
            variant="text"
            sx={{
              color: subType === 'second' ? theme.palette.primary.main : SFPalette.grey2,
            }}
            onClick={() => {
              setSubType('second');
              setTypes && setTypes('second')
              onSelectSecond && onSelectSecond();
            }}
          >
            <Typography variant="h6" fontWeight={700}>
              {secondText}
            </Typography>
          </CustomButton>
        </MaskBox>
      </Box>
    </>
  );
}
